<template>
  <svg
    id="Component_174_3"
    data-name="Component 174 – 3"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      id="Path_1734"
      data-name="Path 1734"
      d="M21389,3034.836h20"
      transform="translate(-21389.004 -3024.836)"
      fill="none"
      stroke="#b40068"
      stroke-width="3"
    />
    <path
      id="Path_1735"
      data-name="Path 1735"
      d="M0,0H20"
      transform="translate(10.003 20) rotate(-90)"
      fill="none"
      stroke="#b40068"
      stroke-width="3"
    />
  </svg>
</template>

<script>
export default {
  name: 'AddSimplified',
}
</script>

<style lang="scss" scoped></style>
